<template>
  <div id="printm">
    <div style="" class="common-page common-head mt20 printhide flex tem-header">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>$router.push('../report/report-list')
      </div>-->
      <div class="ml20 mt20 f18 blue cursor" @click="$router.back()"><i class="el-icon-back"></i>返回</div>
      <div class="flex">
        <el-form>
          <el-form-item label="切换数据" label-width="80px">
            <el-select size="small" @change="changeData" v-model="linkUrl">
              <el-option v-for="(item, index) in portList" :value="Number(item.code)" :label="item.name" :key="index">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div class="ml20 mt10 flex">
      <el-form>
        <el-form-item label="切换数据" label-width="80px">
          <el-select size="small" @change="changeData" v-model="linkUrl">
            <el-option v-for="item in portList" :value="Number(item.code)" :label="item.name">{{ item.name }}</el-option>

          </el-select>
        </el-form-item>
      </el-form>
    </div> -->
    <div class="f-list flex">
      <div class="flex1 flex" style="flex-direction: column; align-item: center">
        <div v-if="$route.query.type == 1 || !$route.query.type">
          <div id="tab1" class="tab1"></div>
          <div id="tab2" class="tab1"></div>
          <div id="tab3" class="tab1"></div>
        </div>
        <div v-if="$route.query.type == 2 || $route.query.type == 5 || !$route.query.type">
          <div>
            <div class="common-page common-tool-bar" style="margin-right: 20px">
              <!-- <el-date-picker
          v-model="params.time"
          @change="changetime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
              <!-- <el-date-picker
                v-model="params.time"
                type="month"
                @change="changetime"
                :clearable="false"
                :editable="false"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker> -->
              <el-date-picker v-model="params.starttime" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
              <span class="ml10" style="margin-top: 5px">至</span>
              <el-date-picker class="ml10" v-model="params.endtime" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
              <div class="btn align-center ml10" @click="searchSubmit"><i class="icon-tr-search"></i>查询</div>
              <div class="btn ml10 align-center" @click="resetSearch">重置</div>
            </div>
          </div>
          <div id="tab4" class="tab1"></div>
          <div id="tab5" class="tab1"></div>
        </div>
      </div>
    </div>

    <!-- <div class="center mt20 printhide" style="margin-bottom:20px">
             <el-button type="primary" v-print="'#printm'">打印报表</el-button>

    </div> -->
  </div>
</template>
<script>
import echarts from "echarts";
import { getTime } from "../../api/common.js";
import unitList from "@/components/unitList";
export default {
  inject: ["reload"],

  data() {
    return {
      power: 0,
      value1: [], // 时间查询
      portList: [],
      c_num: this.$route.query.c_num,
      linkUrl: Number(this.$route.query.type),
      params: {
        time: "",
        starttime: "",
        page: 1,
        percentage_name: "",
        endtime: "",
        company_num: "",
      },
      // wbLoad = false,
      timeer: null,
      nowIndex: 0,
      companyName: this.$route.query.name,
      getColor: "#b3eeca",
      lostColor: "#da6b6b",
      // oneData:[],
      oneData: [], //巡查点隐患
      fourData: [], //巡查整改情况
      twoData: [], // 巡查点位数量
      threeData: [], //巡查人员次数
      wbList: [], // 所有的维保数据
      jcList: [], // 所有的检测数据
    };
  },
  created() {
    this.$get(`/trxf/main/xf/companyInfo/getCPort/${this.c_num || this.$route.query.c_num}`).then((res) => {
      this.portList = res.data;
    });
    // setTimeout(() => {}, 20);
  },
  mounted() {
    this.getList();
  },
  destroyed() {
    this.resetTimer();
  },
  //     watch:{
  //     cpNum(){
  //          this.getList()
  //     }

  // },
  methods: {
    changeData() {
      var query = {};
      switch (this.linkUrl) {
        case 1:
          query = { c_num: this.c_num, name: this.$route.query.name, type: 1 };
          break;
        case 2:
          query = { c_num: this.c_num, name: this.$route.query.name, type: 2 };
          break;
        case 5:
          query = {
            c_num: this.c_num,
            name: this.$route.query.name,
            type: this.linkUrl,
          };
          break;
        case 8:
          query = { c_num: this.c_num, name: this.$route.query.name, type: 8 };
          this.$local.save("company", {
            c_company_num: this.c_num,
            c_name: this.$route.query.name || "",
          });
          break;
        default:
          query = {
            id: this.c_num,
            name: this.$route.query.name,
            type: this.linkUrl,
          };
      }
      var obj = {
        1: "/score/detail",
        2: "/score/detail",
        3: "/report/report-detail",
        4: "/report/report-detail",
        5: "/score/detail",
        7: "/report/electronic-detail",
        8: "/safe/safe-statistics",
      };

      this.$router.replace({ path: obj[this.linkUrl], query }).then((res) => {
        setTimeout(() => {
          var url = this.linkUrl;
          this.reload();
          this.linkUrl = url;
        }, 100);
      });
    },

    changNum(val) {
      var str = val > 9 ? val : "0" + val;
      return str;
    },
    // changetime(val) {
    //   var arr = val.split("-");
    //   arr.splice(2, 1, "31");
    //   this.params.endtime = arr.join("-");
    //   this.params.starttime = val;
    // },
    searchSubmit() {
      // console.log(this.params);
      // clearTimeout(this.timeer)
      // this.timeer = null
      this.resetTimer();
      this.nowIndex = 0;
      this.getproblem();
    },

    resetTimer() {
      clearTimeout(this.timeer);
      this.timeer = null;
    },
    resetSearch() {
      this.resetTimer();
      this.nowIndex = 0;
      this.params = {
        ...this.params,
        page: 1,
        starttime: "",
        endtime: "",
        // starttime: `${new Date().getFullYear()}-${this.changNum(
        //   new Date().getMonth() + 1
        // )}-01`,
        // endtime: `${new Date().getFullYear()}-${this.changNum(
        //   new Date().getMonth() + 1
        // )}-31`,
        time: "",
      };
      this.getproblem();
    },
    // 三大项饼状图占比
    getPies() {
      this.$post("/phpcontro/scorepicture", { company_id: this.c_num }).then((res) => {
        if (res.data) {
          var arr = [];
          res.data.map((item) => {
            var obj = { name: item.label, value: Number(item.value) };
            arr.push(obj);
          });
          this.makeChart({
            data: arr,
            content: "tab1",
            config: {
              title: {
                left: "center",
                text: `${this.companyName}消防评估汇总图`,
              },
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c} ({d}%)",
              },

              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  radius: "65%",
                  center: ["50%", "60%"],
                  data: arr,

                  itemStyle: {
                    normal: {
                      color: function(params) {
                        let colorList = ["#4472C4", "#7A9BD5", "#ED7D31", "#F6C29D", "#70AD47", "#A9D18E"];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              ],
            },
          });
        }
      });
    },
    // 各个小项得失分统计图
    getAllLines() {
      // 500
      this.$post("/phpcontro/scoreItem", { company_id: this.c_num }).then((res) => {
        var valueArr = res.data[0];
        var namearr = [];
        var plusarr = [];
        var minusarr = [];
        valueArr.map((item) => {
          namearr.push(item.key);
          plusarr.push(Number(item.defen));
          minusarr.push(Number(item.shifen));
        });
        this.makeLine({
          content: "tab3",
          data: valueArr,
          config: {
            title: {
              left: "left",
              text: `${this.companyName}消防评估各项目得分统计`,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              show: true,
              right: 0,
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: namearr,
                axisLabel: {
                  interval: 0,
                  formatter: function(value) {
                    var str = value.split("");
                    return str.join("\n");
                  },
                  textStyle: {
                    color: "#000",
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],

            series: [
              {
                name: "得分",
                type: "bar",
                stack: "得失分",
                data: plusarr,
                radius: "65%",
                label: {
                  show: true,
                  position: "inside",
                  formatter: function(value) {
                    if (!value.data) {
                      return "";
                    }
                  },
                },
                itemStyle: {
                  normal: {
                    color: this.getColor,
                  },
                },
              },
              {
                name: "失分",
                type: "bar",
                stack: "得失分",
                label: {
                  show: true,
                  position: "inside",
                  formatter: function(value) {
                    if (!value.data) {
                      return "";
                    }
                  },
                  // color:"black"
                },
                data: minusarr,
                itemStyle: {
                  normal: {
                    color: this.lostColor,
                  },
                },
              },
            ],
          },
        });
      });
    },

    //  三大项横向统计图
    getUnitLines() {
      this.$post("/phpcontro/scoreHistogram", { company_id: this.c_num }).then((res) => {
        var valueArr = res.data[0];
        var namearr = [];
        var plusarr = [];
        var minusarr = [];
        valueArr.map((item) => {
          namearr.push(item.key);
          plusarr.push(Number(item.defen));
          minusarr.push(Number(item.shifen));
        });
        this.makeLine({
          content: "tab2",
          config: {
            title: {
              left: "left",
              text: `${this.companyName}消防评估分类得分统计`,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              show: true,
              right: 0,
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "value",
              },
            ],
            yAxis: [
              {
                type: "category",
                data: namearr,
                axisLabel: {
                  interval: 0,
                  formatter: function(value) {
                    var str = value.split("");
                    return str.join("\n");
                  },
                  textStyle: {
                    color: "#000",
                  },
                },
              },
            ],

            series: [
              {
                name: "得分",
                type: "bar",
                stack: "得分",
                data: plusarr,
                radius: "65%",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    if (!value.data) {
                      return "";
                    }
                  },
                },
                itemStyle: {
                  normal: {
                    color: this.getColor,
                  },
                },
              },
              {
                name: "失分",
                type: "bar",
                stack: "失分",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    if (!value.data) {
                      return "";
                    }
                  },
                  // color:"black"
                },
                data: minusarr,
                itemStyle: {
                  normal: {
                    color: this.lostColor,
                  },
                },
              },
            ],
          },
        });
      });
    },
    //   获取维保问题
    getWbProblems() {
      this.params.company_num = this.c_num;
      this.params.type = this.$route.query.type;
      // this.interve()
      this.$post("/score/scorelist", this.params).then((res) => {
        this.wbList = res.data; // 所有月份维保数据
        this.interve();
      });
    },
    getJCPeoblems() {
      this.params.company_num = this.c_num;
      this.params.type = this.$route.query.type;
      console.log(this.params);
      // this.interve()
      this.$post("/score/scorelist", this.params).then((res) => {
        this.jcList = res.data; // 所有月份维保数据
        // this.interve();
        this.JCData(this.jcList[0]);
      });
    },
    //启动计时器
    interve() {
      this.wbData(this.wbList[this.nowIndex]);

      this.timeer = setInterval(() => {
        //  渲染数据
        // this.wbLoad = false
        var index = this.nowIndex;

        index++;
        this.wbData(this.wbList[this.nowIndex]);

        this.nowIndex = index;
        if (this.nowIndex > this.wbList.length - 1) {
          this.nowIndex = 0;
        }
      }, 5000);
    },
    stopinter(id) {
      if (this.$route.query.type == 5) return;
      var _this = this;
      var Odiv = document.getElementById(id);
      Odiv.onmouseover = function() {
        _this.resetTimer();
      };
      Odiv.onmouseout = function() {
        //  clearTimeout(_this.timeer)
        // _this.timmer = null
        _this.resetTimer();
        _this.interve();
      };
    },
    JCData(arr) {
      // console.log(arr);
      let xAxis = [],
        barlist = [[], [], [], [], [], []],
        colorList = ["#597bf6", "#6be648", "#e6be30", "#839cf4", "#7fe8a9", "#f7d56e"],
        lineColorList = ["#b3eeca", "#da6b6b", "#6584f6"],
        barTitleList = ["A项完好占比", "B项完好占比", "C项完好占比", "A项发现问题占比", "B项发现问题占比", "C项发现问题占比"],
        lineTitleList = ["A项发现问题趋势", "B项发现问题趋势", "C项发现问题趋势"],
        lineList = [];

      // 处理数据格式
      for (const key in arr?.date) {
        if (Object.hasOwnProperty.call(arr.date, key)) {
          // 初始化lineList数组
          xAxis.push(key);
          // let firstAscll = arr.date[key][0].uuid_kid.charCodeAt()

          barTitleList.forEach((item, index) => {
            // barlist[index]
            typeof barlist[index] != "object" ? (barlist[index] = []) : "";
            console.log(index % 2);
            index % 2
              ? barlist[index].push(
                  !arr.date[key].find((it) => {
                    return 2 * (it.uuid_kid.charCodeAt() - 65) + 1 == index;
                  })
                    ? 0
                    : Number(
                        arr.date[key].find((it) => {
                          return 2 * (it.uuid_kid.charCodeAt() - 65) + 1 == index;
                        }).percentage_score,
                      ),
                )
              : barlist[index].push(
                  !arr.date[key].find((it) => {
                    return 2 * (it.uuid_kid.charCodeAt() - 65) == index;
                  })
                    ? 0
                    : Number(
                        100 -
                          arr.date[key].find((it) => {
                            return 2 * (it.uuid_kid.charCodeAt() - 65) == index;
                          }).percentage_score,
                      ),
                );
          });

          // arr.date[key].forEach((item) => {
          // 	// if (!barlist[2 * (item.uuid_kid.charCodeAt() - 65)]) {
          // 	//   barlist.push([]);
          // 	//   barlist.push([]);
          // 	// }
          // 	typeof barlist[2 * (item.uuid_kid.charCodeAt() - 65)] != "object"
          // 		? (barlist[2 * (item.uuid_kid.charCodeAt() - 65)] = [])
          // 		: "",
          // 		barlist[2 * (item.uuid_kid.charCodeAt() - 65)].push(Number(item.percentage_score));
          // 	typeof barlist[2 * (item.uuid_kid.charCodeAt() - 65) + 1]
          // 		? (barlist[2 * (item.uuid_kid.charCodeAt() - 65) + 1] = [])
          // 		: "",
          // 		barlist[2 * (item.uuid_kid.charCodeAt() - 65) + 1].push(
          // 			100 - Number(item.percentage_score)
          // 		);
          // });
        }
      }
      console.log(xAxis, barTitleList, barlist);
      // 处理数据 使用解构交换数据 0 1 2 3 4 5 -> 0 2 4 1 3 5
      [barlist[1], barlist[3]] = [barlist[3], barlist[1]];
      [barlist[1], barlist[2]] = [barlist[2], barlist[1]];
      [barlist[2], barlist[4]] = [barlist[4], barlist[2]];
      let barSeriesList = barlist.map((item, index) => {
        return {
          name: barTitleList[index],
          type: "bar",
          color: colorList[index],
          stack: String.fromCharCode((index % 3) + 65),
          label: {
            show: true,
          },
          emphasis: {
            focus: "series",
          },
          data: item,
        };
      });

      console.log(barSeriesList, barlist);
      let lineSeriesList = [];
      if (barlist.length > 0)
        lineSeriesList = lineTitleList.map((item, index) => {
          return {
            name: item,
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: lineColorList[index],
            },
            data: barlist[index + 3],
          };
        });
      this.makeLine({
        content: "tab4",
        config: {
          title: {
            text: `${this.companyName + (arr?.month ?? "")}检测发现与解决问题趋势图`,

            // x:'center',
            subtext: "项目名",
            // left:'-10',
          },
          legend: {
            right: 0,
            data: barTitleList,
            width: 600,
            itemWidth: 20,
            formatter: ["{a|{name}}"].join("\n"),
            textStyle: {
              rich: {
                a: {
                  width: 120, // 每个图例的宽度，具体根据字数调整
                  lineHeight: 12,
                },
              },
            },
          },
          tooltip: {
            trigger: "axis",
            show: true,
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            // formatter: function(params) {
            // 	return `项目名称:${namearr[params[0].dataIndex]}`;
            // },
          },

          xAxis: [
            {
              type: "category",
              // data: namearr,
              data: xAxis,
              axisLabel: {
                formatter: function(value) {
                  var str = value.split("");
                  return str.join("\n");
                },
              },
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "百分比",
              min: 0,

              nameTextStyle: {
                // x轴name的样式调整
                color: "#000",
                fontSize: 14,
                padding: [0, -40, 0, 0, 0], // 加上padding可以调整其位置
              },
              axisLabel: {
                formatter: "{value}%",
              },
            },
          ],
          series: barSeriesList,
        },
      });
      this.makeLine({
        content: "tab5",
        config: {
          title: {
            text: `${this.companyName + (arr?.month ?? "")}检测发现与解决问题趋势图`,

            // x:'center',
            subtext: "项目名",
          },
          legend: {
            right: 0,
          },
          tooltip: {
            trigger: "axis",
            show: true,
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function(params) {
              // return `项目名称:${namearr[params[0].dataIndex]}`;
            },
          },

          xAxis: [
            {
              type: "category",
              // data: namearr,
              data: xAxis,
              axisLabel: {
                formatter: function(value) {
                  var str = value.split("");
                  return str.join("\n");
                },
              },
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "百分比",
              min: 0,
              nameTextStyle: {
                // x轴name的样式调整
                color: "#000",
                fontSize: 14,
                padding: [0, -50, 0, 0, 0], // 加上padding可以调整其位置
              },

              axisLabel: {
                formatter: "{value}%",
              },
            },
          ],
          //
          //#6584f6
          series: lineSeriesList,
        },
      });
    },
    wbData(arr) {
      //   console.log(arr);
      var namearr = [];
      var plusarr = [];
      var minusarr = [];
      // var timeArr = [];
      var lineArr = []; // 趋势折现
      var goodArr = [];
      if (arr.date.length) {
        var valueArr = arr.date;

        valueArr.map((item) => {
          namearr.push(item.percentage_name);
          plusarr.push(Number(item.percentage_score) - Number(item.percentage_lose)); // 未解决问题
          minusarr.push(Number(item.percentage_lose)); // 已解决问题
          goodArr.push(Number(item.percentage_score) ? 100 - Number(item.percentage_score) : 0);
          lineArr.push(Number(item.percentage_score) ? 100 - Number(item.percentage_score) - Number(item.percentage_lose) + Number(item.percentage_lose) : 0);
        });
      } else {
      }
      // console.log(namearr);

      this.makeLine({
        content: "tab5",
        config: {
          title: {
            text: `${this.companyName + arr.month}维保发现与解决问题趋势图`,

            // x:'center',
            subtext: "项目名",
          },
          legend: {
            right: 0,
          },
          tooltip: {
            trigger: "axis",
            show: true,
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function(params) {
              return `项目名称:${namearr[params[0].dataIndex]}`;
            },
          },

          xAxis: [
            {
              type: "category",
              data: namearr,
              axisLabel: {
                formatter: function(value) {
                  var str = value.split("");
                  return str.join("\n");
                },
              },
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "百分比",
              min: 0,

              axisLabel: {
                formatter: "{value}%",
              },
            },
          ],

          series: [
            {
              name: "未解决趋势",
              type: "line",
              label: {
                show: true,
                position: "top",
              },
              itemStyle: {
                color: "#da6b6b",
              },
              data: plusarr,
            },
            {
              name: "已解决趋势",
              type: "line",
              label: {
                show: true,
                position: "top",
              },
              itemStyle: {
                color: "#b3eeca",
              },
              data: minusarr,
            },
          ],
        },
      });
      this.makeLine({
        content: "tab4",
        config: {
          title: {
            text: `${this.companyName + arr.month}维保发现与解决问题占比`,
          },
          legend: {
            right: 0,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },

          xAxis: [
            {
              type: "category",
              data: namearr,
              axisLabel: {
                interval: 0,
                formatter: function(value) {
                  var str = value.split("");
                  return str.join("\n");
                },
              },
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "百分比",
              min: 0,

              axisLabel: {
                formatter: "{value}%",
              },
            },
          ],

          series: [
            {
              name: "完好占比",
              type: "bar",
              stack: "整改程度",
              label: {
                show: true,
                position: "inside",
              },
              itemStyle: {
                color: "#94aaee",
              },
              data: goodArr,
            },
            {
              name: "已解决问题百分比",
              type: "bar",
              stack: "整改程度",
              label: {
                show: true,
                position: "inside",
              },
              itemStyle: {
                color: this.getColor,
              },
              data: minusarr,
            },
            {
              name: "未解决问题占比",
              type: "bar",
              stack: "整改程度",
              label: {
                show: true,
                position: "inside",
              },
              itemStyle: {
                color: this.lostColor,
              },
              data: plusarr,
            },
            {
              name: "已解决问题趋势",
              type: "line",

              label: {
                show: false,
              },
              itemStyle: {
                color: "#000",
              },
              data: lineArr,
            },
          ],
        },
      });
    },

    getList() {
      // 单位得分饼图
      // console.log()
      if (this.$route.query.type == 5 || this.$route.query.type == 2) this.getproblem();
      else {
        this.getPies();
        this.getAllLines();
        this.getUnitLines();
        this.getproblem();
      }
    },
    getproblem() {
      // console.log(this.$route);
      if (this.$route.query.type == 2) this.getWbProblems();
      else if (this.$route.query.type == 5) this.getJCPeoblems();
    },
    // searchSubmit() {
    //   // function changeArr(val) {
    //   //   var arr = val.split(" ");
    //   //   var n = arr[0].replace(/['年','月']/g, "-");
    //   //   n = n.replace(/日/g, "");
    //   //   return n;
    //   // }
    //   this.clear();

    //   // console.log(this.params)
    //   // return
    //   //  console.log(this.params)
    //   this.getList();
    // },

    clear() {},

    makeLine({ data, content, config }) {
      var _this = this;
      var option = {
        title: {
          text: "多单位失分对比统计图",
          // subtext: '测试'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: ["单位甲", "单位乙", "单位丙", "单位丁", "单位戊", "单位己", "单位庚"],
        },

        series: [
          {
            name: "得分",
            type: "bar",
            stack: "得分",
            data: [32, 21, 20, 30, 33, 43, 6],
            label: {
              show: true,
              position: "right",
            },
          },
          {
            name: "失分",
            type: "bar",
            stack: "失分",
            data: [32, 21, 20, 30, 33, 43, 6],
            label: {
              show: true,
              position: "right",
            },
          },
        ],
      };
      if (config) {
        option = { ...option, ...config };
      }
      let myContent = document.getElementById(content);
      if (option.series.length <= 0) myContent.style.display = "none";
      var myChart = echarts.init(myContent);
      myChart.setOption(option);
      this.stopinter(content);
      if (this.$store.state.user.company.cCompanyNum === "aaa") {
        myChart.getZr().on("click", function(params) {
          let point = [params.offsetX, params.offsetY];

          let xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, point)[0];
          let op = myChart.getOption();
          let name = op.xAxis[0].data[xIndex];
          console.log(name);
          console.log(data[xIndex].num);
          _this.$router.push({
            path: "/score/scoreList",
            query: {
              c_num: data[xIndex].num,
              c_name: name,
            },
          });
        });
      }
    },
    //饼图
    makeChart({ data, content, config }) {
      // console.log(this.chartList)

      let option = {
        title: {
          text: "单位得分项饼图",
          subtext: "纯属虚构",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          show: true,
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 28, name: "安全管理得分" },
              { value: 2, name: "安全管理失分" },
              { value: 30, name: "消防设施得分" },
              { value: 5, name: "消防设施失分" },
              { value: 25, name: "建筑防火得分" },
              { value: 10, name: "建筑防火失分" },
            ],
            itemStyle: {
              normal: {
                color: function(params) {
                  let colorList = ["#3300CC", "#000066", "#CC0000", "#990000", "#CCCC33", "#CC9933"];
                  return colorList[params.dataIndex];
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      if (option) {
        option = { ...option, ...config };
      }
      echarts.init(document.getElementById(content)).setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.tab1 {
  width: 80%;
  min-height: 400px;
  margin: 20px auto 20px auto;
}

#line {
  height: 250px;
  width: 100%;
}

#tab3,
#tab4,
#tab5 {
  height: 600px;
}

@media print {
  #tab1,
  #tab2,
  #tab3,
  #tab4,
  #tab5,
  #tab6 {
    margin-top: 120px;
    width: 100%;
  }

  .printhide {
    display: none;
  }

  #printm {
  }
}
.tem-header {
  display: flex;
  justify-content: space-between;
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
.content {
  display: flex;
  width: 100%;
  height: 100%;
  .left {
    width: 20%;
    padding-left: 20px;
  }
  .right {
    width: 80%;
  }
}
</style>
